
import { Autocomplete, Box, Card, CardContent, Grid, Tab, Tabs, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { EAbhyasFilesComponent } from "./eabhyasFiles";
import { SchoolFilesComponent } from "./schoolFiles";
import { ISharedFileComponentProps } from "./sharedFilesModel";
import { NotificationFilesComponent } from "./notificationFiles";
import { useNavigate, useParams } from "react-router-dom";
import { ISchoolSummaryModel } from "../../facilitator/models/ISchoolModel";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";
import FacilitatorService from "../../facilitator/facilitatorService";
import { toast } from "react-toastify";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const toNumber = (value?: string | null): number | undefined => {
    return value != null ? Number(value) : undefined;
  };
export const SharedFilesComponent = (props: ISharedFileComponentProps) => {
    const schoolSwitch = props.schoolSwitch;
    const [tabValue, setTabValue] = React.useState(0);
    const navigate = useNavigate();
    const params = useParams();
    const schoolIdParam = params.schoolId ?? '';
    const [schoolList, setSchoolList] = useState<ISchoolSummaryModel[]>([]);
    const [selectedSchool, setSelectedSchool] = useState<ISchoolSummaryModel | null>(null);
    const [schoolsLoading, setSchoolsLoading] = useState(false);
    const handleSchoolChange = (newValue: ISchoolSummaryModel | null) => {
        setSelectedSchool(newValue);
        if (newValue?.userId)
            navigate('/Facilitator/sharedfiles/' + newValue?.userId);
        else
            navigate('/Facilitator/sharedfiles');
    };
    useEffect(() => {
        setSchoolsLoading(true);
        FacilitatorService.getSchoolsSummary().then((res: IHTTPResponse<IAPIResponse<ISchoolSummaryModel>>) => {
            if (res?.data?.errors?.length > 0) {
                res?.data?.errors.forEach((i) => toast.error(i.message));
            }
            else {
                setSchoolList(res.data.list);
                setSelectedSchool(res.data.list.find(i => i.userId.toString() === schoolIdParam) ?? null);
            }
        }).finally(() => setSchoolsLoading(false));
    }, [schoolIdParam]);
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };
    return (
        <Grid container sx={{ height: "100%" }}>
            <Grid item xs={12}>
                <Card sx={{ height: "100%" }}>
                    <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>

                        {/* ── Toolbar: Tabs (left) + School selector (right) ── */}
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            borderBottom: 1,
                            borderColor: 'divider',
                            px: 3,
                            bgcolor: 'grey.50',
                            flexWrap: 'wrap',
                            gap: 2,
                        }}>
                            <Tabs
                                value={tabValue}
                                onChange={handleTabChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                sx={{
                                    minHeight: 48,
                                    '& .MuiTab-root': {
                                        textTransform: 'none',
                                        fontWeight: 500,
                                        fontSize: '0.875rem',
                                        minHeight: 48,
                                        px: 2.5,
                                        color: 'text.secondary',
                                        '&.Mui-selected': { fontWeight: 700, color: 'primary.main' },
                                    },
                                    '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' },
                                }}
                            >
                                <Tab label='e-Abhyas Files' {...a11yProps(0)} />
                                <Tab label='School Files' {...a11yProps(1)} />
                                <Tab label='Notification Files' {...a11yProps(2)} />
                            </Tabs>

                            {schoolSwitch && (
                                <Autocomplete
                                    disablePortal
                                    options={schoolList}
                                    getOptionLabel={(option) => `${option.userName} | ${option.schoolName}`}
                                    sx={{ width: 360 }}
                                    value={selectedSchool}
                                    loading={schoolsLoading}
                                    onChange={(event, newValue) => handleSchoolChange(newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select School"
                                            variant="outlined"
                                            size="small"
                                        />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.userId === value.userId}
                                />
                            )}
                        </Box>

                        <CustomTabPanel value={tabValue} index={0}>
                            <EAbhyasFilesComponent {...props} schools={schoolList} selectedSchoolId={toNumber(schoolIdParam)} />
                        </CustomTabPanel>
                        <CustomTabPanel value={tabValue} index={1}>
                            <SchoolFilesComponent {...props} selectedSchoolId={toNumber(schoolIdParam)} />
                        </CustomTabPanel>
                        <CustomTabPanel value={tabValue} index={2}>
                            <NotificationFilesComponent {...props} />
                        </CustomTabPanel>

                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}